import {
  Skeleton,
  DefaultPageSkeleton,
  BaseLayout,
  Header,
  Navigation
} from '@efast_public/fjd-component-library';

export function LayoutSkeleton() {
  return (
    <BaseLayout
      footer={<Skeleton width={1000} height={40} />}
      header={
        <Header
          logo={<Skeleton width={200} height={40} />}
          navigation={<Skeleton width={200} height={40} />}
        />
      }
      navigation={
        <Navigation>
          <Navigation.NavigationItem
            icon="table-split"
            label={'Antragsübersicht'}
            disabled
          />
          <Navigation.NavigationItem
            icon="edit"
            label={'Schreibtisch'}
            disabled
          />
        </Navigation>
      }
    >
      <DefaultPageSkeleton />
    </BaseLayout>
  );
}
